export default function initDropdown() {
  Alpine.data('dropdown', (defaultState: boolean | undefined) => ({
    open: defaultState === undefined? false : defaultState,
    toggleDialog() {
      this.open = !this.open;
    },
    openDialog() {
      this.open = true;
    },
    closeDialog() {
      this.open = false;
    },
    listClasses(){
      return this.open ? 'max-h-96': 'max-h-0';
    },
    iconClasses(){
      return this.open ? 'rotate-180': '';
    }
  }));
}
